import React from "react";
import PropTypes from "prop-types";
import { SCOPE_TEAM, SCOPE_VENUES, formatCents } from "../giftCardFormat";

const scopeSentence = (scope, teamName, venueNames) => {
  if (scope === SCOPE_TEAM) return `Works at any ${teamName} venue`;
  if (scope === SCOPE_VENUES && venueNames.length > 0) return `Works at ${venueNames.join(", ")} only`;
  if (scope === SCOPE_VENUES) return "Pick the venues it works at";
  return "Works at any Opendate venue";
};

const GiftCardPreview = ({
  name,
  teamName,
  currency,
  artworkUrl,
  denominationsCents,
  customAmounts,
  scope,
  venueNames,
  expiresInMonths,
  purchasePath,
}) => {
  const chips = denominationsCents.map((cents) => formatCents(cents, currency, { whole: true }));
  if (customAmounts) chips.push("Other");
  const headline = denominationsCents.length > 0 ? formatCents(denominationsCents[0], currency, { whole: true }) : "—";

  return (
    <div className="gift-card-preview" data-testid="gift-card-preview">
      <div className="gift-card-preview-heading">
        <span className="gift-card-preview-label">Purchase page preview</span>
        <span className="gift-card-preview-path">{purchasePath || "Link appears after the first save"}</span>
      </div>
      <div className="gift-card-preview-page">
        <div
          className="gift-card-preview-art"
          style={artworkUrl ? { backgroundImage: `url("${artworkUrl}")` } : undefined}
          data-testid="gift-card-preview-art"
        >
          <span className="gift-card-preview-team">{teamName}</span>
          <div className="gift-card-preview-art-footer">
            <span>Gift card</span>
            <span className="gift-card-preview-amount">{headline}</span>
          </div>
        </div>
        <h3 className="gift-card-preview-name">{name || "Untitled gift card"}</h3>
        <div className="gift-card-preview-chips">
          {chips.map((chip) => (
            <span key={chip} className="gift-card-preview-chip">
              {chip}
            </span>
          ))}
        </div>
        <p className="gift-card-preview-line">{scopeSentence(scope, teamName, venueNames)}</p>
        <p className="gift-card-preview-line">
          {expiresInMonths ? `Expires ${expiresInMonths} months after purchase` : "Never expires"}
        </p>
      </div>
    </div>
  );
};

GiftCardPreview.propTypes = {
  name: PropTypes.string,
  teamName: PropTypes.string.isRequired,
  currency: PropTypes.string,
  artworkUrl: PropTypes.string,
  denominationsCents: PropTypes.arrayOf(PropTypes.number).isRequired,
  customAmounts: PropTypes.bool.isRequired,
  scope: PropTypes.string.isRequired,
  venueNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  expiresInMonths: PropTypes.number,
  purchasePath: PropTypes.string,
};

export default GiftCardPreview;
